import fetch from '@/utils/fetch';
import filterNull from '@/utils/filterNull';
import { message } from 'antd';
import moment from 'moment';
import { RejectPositionItem } from './constants';
import { InferModelProps } from '@/store/withStore';
import { CityListResult, getCityList } from '@/apis/commonApi';

const model = {
  state: {
    licenseData: {},
    bdList: [], // 商圈列表
    cities: [],
    restaurantDetail: null, // 餐厅资质所有信息
    rejectReasonHealth: {}, // 健康证信息
    rejectReasonDoor: {}, // 门头信息
    rejectReasonKitchen: {}, // 后厨信息
    rejectReasonOffice: {}, // 前厅信息
    healthLicenseList: [], // 健康证重复列表
    AccountList: [], // 商拓账号列表
    cacheTime: -1,
    cacheKey: '0',
  },
  reducers: {
    setState(state: any, partialState: any) {
      return { ...state, ...partialState };
    },
  },
  actions: ({ dispatch: { shopLicense }, getState }: { dispatch: any; getState: any }) => ({
    // 获取资质详情
    async postlicenseDetail(licenseId: number, shopId, subShopId) {
      const { union_shop_id } = getState().basic;
      const data = await fetch('/saasmerchant/web/shoplicense/manage/licenseVerifyDetail', {
        type: 'POST',
        useJson: true,
        params: {
          licenseId,
          unionShopId: union_shop_id,
          shopId,
          subShopId,
        },
      });
      if (data) {
        const licenseData = data.shopLicenseInfoVO || {};
        licenseData.shopName = data.shopName;
        licenseData.shopPhone = data.shopPhone;
        licenseData.shopPhoneHiddenId = data.shopPhoneHiddenId;
        licenseData.auditTime = data.auditTime;
        licenseData.address = data.address;
        licenseData.businessDistrictName = data.businessDistrictName;
        licenseData.shopContact = data.shopContact;
        licenseData.shopContactHiddenId = data.shopContactHiddenId;
        licenseData.updateTimeStr = data.updateTimeStr;
        licenseData.city = data.city;
        licenseData.licenseExpiredInfo = data.licenseExpiredInfo;
        licenseData.permitExpiredInfo = data.permitExpiredInfo;
        licenseData.registerNoSameVo = data.registerNoSameVo;
        licenseData.permitNoSameVo = data.permitNoSameVo;
        licenseData.officeSpaceUrl = data.officeSpaceUrl;
        licenseData.legalPersonUrl = data.legalPersonUrl;
        licenseData.companyLogoUrl = data.companyLogoUrl;
        licenseData.majorProductUrl = data.majorProductUrl;
        licenseData.merchantType = data.merchantType;
        // licenseData.rejectReason = data.rejectReason;
        shopLicense.setState({ licenseData });
      }
    },
    // 清空详情页
    resetLicenseData() {
      shopLicense.setState({ licenseData: {} });
    },
    // 资质审批
    async postLicenseVerify(params: any, callback: Function) {
      const data = await fetch('/saasmerchant/web/shoplicense/manage/licenseVerify', {
        type: 'POST',
        useJson: true,
        params: filterNull(params),
      });
      if (data) {
        callback();
      }
    },
    // 获取商圈列表
    async getBDList(params) {
      const bdList = await fetch(
        '/saasmerchant/fsarea/businessDistrict/getBusinessDistrictIdByName',
        {
          params,
        },
      );
      shopLicense.setState({ bdList: bdList || [] });
      return bdList;
    },
    // 模糊查询商拓账号列表
    async getBusinessExtAccount(params) {
      const data = await fetch('/saasmerchant/web/auth/account/getBusinessExtAccount', {
        params,
      });
      shopLicense.setState({ AccountList: data || [] });
      return data;
    },
    // 获取省市信息
    async getCities() {
      const data = await getCityList();
      const citiesTreeLoop = (arr: CityListResult[], isLeaf = false) => {
        if (arr?.length) {
          return arr.map((item) => ({
            title: item.label,
            value: item.value,
            key: item.value,
            isLeaf,
            children: (isLeaf && []) || citiesTreeLoop(item.children || [], true),
          }));
        }
        return [];
      };

      shopLicense.setState({
        cities: citiesTreeLoop(data),
      });

      return data;
    },
    // 更新商圈
    async updateBussinessDistrict(params: { shopId: number; subShopId: number }) {
      const { union_shop_id } = getState().basic;
      const data = await fetch(
        '/saasmerchant/web/restaurantlicense/manage/updateBusinessDistrict',
        {
          type: 'POST',
          useJson: true,
          params: {
            unionShopId: union_shop_id,
            ...params,
          },
        },
      );
      if (data) {
        message.success('商圈已更新');
      }
      return data;
    },
    // 获取餐厅资质信息
    async getRestaurantDetail(licenseId: number, shopId: number, subShopId: number) {
      const data = await fetch(
        '/saasmerchant/web/restaurantlicense/manage/restaurantlVerifyDetail',
        {
          type: 'POST',
          useJson: true,
          params: {
            licenseId,
            shopId,
            subShopId,
          },
        },
      );
      if (data) {
        const { restaurantBaseVO } = data;
        shopLicense.setState({
          restaurantDetail: {
            ...data,
            shopId: restaurantBaseVO?.shopId,
            subShopId: restaurantBaseVO?.subShopId,
            verifyStatus: restaurantBaseVO?.verifyStatus,
            reviewerUserName: restaurantBaseVO?.reviewerUserName,
            verifyTime: restaurantBaseVO?.verifyTime
              ? moment(restaurantBaseVO?.verifyTime).format('YYYY-MM-DD HH:mm:ss')
              : undefined,
          },
        });

        restaurantBaseVO.rejectReasonList.map((item) => {
          switch (item.rejectPosition) {
            default:
              return item;
            case RejectPositionItem.DOOR:
              item.urlList = restaurantBaseVO.restaurantDoorUrlList;
              shopLicense.setState({ rejectReasonDoor: item });
              return item;
            case RejectPositionItem.KITCHEN:
              item.urlList = restaurantBaseVO.restaurantKitchenUrlList;
              shopLicense.setState({ rejectReasonKitchen: item });
              return item;
            case RejectPositionItem.OFFICE:
              item.urlList = restaurantBaseVO.restaurantOfficeUrlList;
              shopLicense.setState({ rejectReasonOffice: item });
              return item;
            case RejectPositionItem.HEALTH:
              item.healthList = restaurantBaseVO.restaurantHealthList; // health中还有别的信息
              shopLicense.setState({ rejectReasonHealth: item });
              return item;
          }
        });
      }
      return data;
    },
    clearRestaurantDetail() {
      shopLicense.setState({
        rejectReasonDoor: {},
        rejectReasonKitchen: {},
        rejectReasonOffice: {},
        rejectReasonHealth: {},
        restaurantDetail: {},
      });
    },
    // 餐厅资质审核
    async postRestautantLicence(params) {
      const {
        restaurantBaseVO: { restaurantLicenseId },
        shopId,
        subShopId,
        shopName,
      } = getState().shopLicense.restaurantDetail;
      const verifyStatus = Object.values(params).find(
        (item: any) => typeof item === 'number' && item > 0,
      )
        ? 2
        : 1; // verifyStatus 审核状态 1:通过 2:拒绝
      const handleParams = (obj) => {
        if (typeof obj !== 'object' || obj === null) {
          throw new Error('obj is not Object');
        }
        const arr = [];
        Object.entries(obj).forEach(([key, value]) => {
          const [rejectPosition, prop] = key.split('-');
          if (!arr[rejectPosition]) {
            arr[rejectPosition] = {
              rejectPosition: Number(rejectPosition),
              [prop]: value,
            };
          } else {
            arr[rejectPosition][prop] = value;
          }
        });
        return arr.filter(Boolean);
      };
      const rejectDetailList = handleParams(params);
      const data = await fetch(
        '/saasmerchant/web/restaurantlicense/manage/restaurantLicenseVerify',
        {
          type: 'POST',
          useJson: true,
          params: {
            verifyStatus,
            restaurantLicenseId,
            shopId,
            subShopId,
            rejectDetailList,
            shopName,
          },
        },
      );
      return data;
    },
    // 健康证查重列表
    async getHealthLicenseVerify(restaurantHealthNo: string, restaurantLicenseId: string) {
      const { restaurantDetail } = getState().shopLicense;
      const data = await fetch('/saasmerchant/web/restaurantlicense/manage/healthLicenseVerify', {
        type: 'POST',
        useJson: true,
        params: {
          restaurantHealthNo,
          restaurantLicenseId,
          shopId: restaurantDetail?.shopId,
          subShopId: restaurantDetail?.subShopId,
        },
      });
      data && shopLicense.setState({ healthLicenseList: data });
    },
    // 资质管理导出
    async exportQualificationList(params) {
      const data = await fetch('/saasmerchant/web/restaurantlicense/manage/qualificationDown', {
        type: 'POST',
        useJson: true,
        params: {
          ...params,
        },
      });
      data && message.success('导出任务添加成功');
    },
    // 餐厅免信息
    async postRestaurantMessage(params: {
      restaurantLicenseId: number;
      shopId: number;
      subShopId: number;
      verifyStatus: number;
    }) {
      const data = await fetch('/saasmerchant/web/restaurantlicense/manage/breaks', {
        type: 'POST',
        useJson: true,
        params: {
          ...params,
        },
      });
      data && message.success(`${params.verifyStatus === 1 ? '已成功免信息' : '已取消免信息'}`);
      return data;
    },
    setCacheKey(key) {
      shopLicense.setState({
        cacheKey: key,
      });
    },
    setCacheTime(time) {
      shopLicense.setState({
        cacheTime: time,
      });
    },
  }),
};

export type ModelProps = InferModelProps<typeof model>;

export default model;
